import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var PhoneSystemIcon = function PhoneSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M14.732 22.972l.012.006c2.44 1.555 5.664 1.2 7.73-.865l.768-.767a2.58 2.58 0 000-3.646l-3.232-3.23a2.58 2.58 0 00-3.646 0 1.077 1.077 0 01-1.524 0L9.67 9.298a1.08 1.08 0 010-1.525 2.576 2.576 0 000-3.645L6.439.894A2.58 2.58 0 002.792.893l-.767.767a6.235 6.235 0 00-.852 7.755l.017.026a50.241 50.241 0 0013.5 13.504l.042.027zM2.436 8.605l-.006-.008a4.731 4.731 0 01.656-5.876l.767-.767a1.08 1.08 0 011.525 0l3.23 3.234a1.077 1.077 0 010 1.524 2.58 2.58 0 000 3.646l5.171 5.172a2.576 2.576 0 003.646 0 1.08 1.08 0 011.525 0l3.231 3.23c.42.421.42 1.104 0 1.525l-.767.767a4.733 4.733 0 01-5.889.646l-.01-.006A48.735 48.735 0 012.435 8.605z"
  })));
};

PhoneSystemIcon.displayName = "PhoneSystemIcon";
PhoneSystemIcon.defaultProps = {
  size: 24
};
PhoneSystemIcon.displayName = "PhoneSystemIcon";
PhoneSystemIcon.iconName = "Phone";
export default PhoneSystemIcon;